export default __webpack_public_path__ + "static/media/google-admanager.987df5e4.svg";